module.exports = __webpack_public_path__ + "assets/Image-Carousel-Next.svg?ver=15ac9d58";